import { useListPhoneNumbersForLocationsQuery } from '@frontend/api-phone-numbers';
import { formatProtobufPhone } from '../utils';
import { useInboxLocationIds } from './use-inbox-location-ids';

type UseDefaultLocationPhonesArgs = {
  locationIds?: string[];
};

export const useDefaultLocationPhones = ({ locationIds: providedLocationIds }: UseDefaultLocationPhonesArgs = {}) => {
  const locationIds = useInboxLocationIds({ locationIds: providedLocationIds });
  return useListPhoneNumbersForLocationsQuery({
    request: {
      locationIds,
      sms: true,
      excludeTenDlc: true,
    },
    options: {
      enabled: locationIds.length > 0,
      select: (data): Record<string, string> => {
        return (
          data.phoneNumbers?.reduce<Record<string, string>>((acc, { locationId, defaultSms, phoneNumber }) => {
            const formattedNumber = formatProtobufPhone(phoneNumber);
            if (defaultSms && formattedNumber) {
              acc[locationId] = formattedNumber;
            }

            return acc;
          }, {}) ?? {}
        );
      },
    },
  });
};
